/**
 * A translatable form of a user-visible message, carried next to the English
 * string (which stays the source of truth for logic and for English).
 *
 * `key` is the English template with {{placeholders}} and must be a string
 * literal: the ZKX UI collects every i18nMessage('…') key for translation.
 * A `count` param makes the key plural; an array param is a list (e.g. network
 * names) that the UI joins for the user's language.
 */
export type I18nMessage = {
  key: string
  params?: Record<string, string | number | string[]>
}

/** One message, or several sentences shown one after the other. */
export type I18nText = I18nMessage | I18nMessage[]

export const i18nMessage = (key: string, params?: I18nMessage['params']): I18nMessage =>
  params ? { key, params } : { key }
